import { render, staticRenderFns } from "./general-setting.vue?vue&type=template&id=664f2c44&scoped=true&"
import script from "./general-setting.vue?vue&type=script&lang=js&"
export * from "./general-setting.vue?vue&type=script&lang=js&"
import style0 from "./general-setting.vue?vue&type=style&index=0&id=664f2c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f2c44",
  null
  
)

export default component.exports